<template lang="pug">
  .products
    .background-header.white
      v-container.white(style="max-width:600px")
        h6.ml-2.my-6 Shopify Products
        p.p2.ml-2.primary500--text  Sync your Shopify products with Yezza
        v-text-field.ma-2.p1(solo flat background-color="basic200"   placeholder='Search product' height="40" v-model="searchText"   hide-details dense rounded outlined)
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600") Search Products
        v-layout.mt-3.ml-2
          v-item-group(v-model="selectedFilter" mandatory)
            v-item(v-for='filter in filters' v-slot:default="{ active, toggle }"  :key="filter.name")
              v-btn.text-capitalize.mx-1(:style="active? 'border-width: 2px; font-weight: bold;' : ''" small height=24 outlined @click="toggle") {{ filter.text }}

    v-container(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .contain-layout(v-else)
        SPProductSync.mt-2(:ecommerce="ecommerce" :checked.sync="checked" :initImport.sync="initImport")
        v-layout.my-6(v-if="products.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.c1.basic500 Products not found or empty
        .items-layout(v-else)
          .list-item.my-2(three-line)
            v-row(v-if="checked.length > 0")
              v-col.pt-0
                v-btn(@click="uncheckAll" outlined small)
                  v-icon(left small) mdi-checkbox-multiple-blank-outline
                  | deselect all
            template(v-for='product in currentProducts')
              shopify-product-item(:product.sync="product" :key="product.id" :initImport.sync="initImport")
      div.mt-4
        y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")

</template>

<script>
import ShopifyProductItem from '@/components/ShopifyProductItem.vue'
import SPProductSync from '@/components/ecommerce/shopify/ShopifyProductSync.vue'

import { mapActions } from 'vuex'
import queryString from 'query-string'
export default {
  name: 'SyncShopifyProducts',
  components: { ShopifyProductItem, SPProductSync },
  props: ['company'],
  data: () => ({
    isFetching: false,
    ecommerce: {},
    initImport: false,
    isTyping: false,
    pageSize: 10,
    page: 1,
    count: 0,
    products: [],
    searchText: '',
    isLoading: false,
    searchCountDown: null,
    selectedFilter: 0,
    filters: [
      {
        text: 'All',
        value: ''
      },
      {
        text: 'Synced',
        value: true
      },
      {
        text: 'Not Sync',
        value: false
      }
    ],
  }),
  mounted () {
    if (this.$route.query.page) {
      this.page = parseInt(this.$route.query.page)
    }
    if (this.$route.query.synced) {
      this.selectedFilter = parseInt(this.$route.query.synced)
    }
    if (this.$route.query.search) {
      this.searchText = this.$route.query.search
    }

    // Create watcher after setting data from query string
    this.$watch('page', val => {
      if (val) {
        this.updateQueryString('page', val)
        this.fetchProducts()
      }
    })
    this.$watch('searchText', val => {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.page = 1
        this.fetchProducts()
        this.updateQueryString('search', val)
      }, 500)
    })
    this.$watch('selectedFilter', val => {
      this.page = 1
      this.fetchProducts()
      this.updateQueryString('synced', val)
    })

    this.fetchEcommerce()
    this.$wamp.subscribe(`shopify-sync-progress:${this.ecommerce.company}`, (args, kwArgs) => {
      this.syncSource = kwArgs.source
      this.syncStatus = kwArgs.status
      this.syncDone = kwArgs.done
      this.syncTotal = kwArgs.total
      // console.log(kwArgs)
      if (kwArgs.status === 'done') {
        this.page = 1
        this.searchText = ''
        this.selectedFilter = 0
        this.fetchProducts()
      }
    })
  },
  computed: {
    currentProducts () {
      return this.products
    },
    checked: {
      get () {
        return [...this.products.filter(f => f.check === true)]
      },
      set (val) {
        this.products.filter(f => f.id === val.real_id)[0].product = val
        this.products.filter(f => f.id === val.real_id)[0].check = false
      }
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchEcommerce () {
      this.$axios.get(`/ecommerce/shopify/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length > 0) {
          this.ecommerce = {...response.data.results[0]}
          this.fetchProducts(1)
        }
        this.isFetching = false
      }).catch(() => {})
    },
    fetchProducts() {
      this.isFetching = true
      let url = `/ecommerce/shopify/products/?page=${this.page}&page_size=${this.pageSize}&settings=${this.ecommerce.id}&ordering=-id`
      const hasProduct = this.filters[this.selectedFilter].value
      if (hasProduct !== '') {
        url += `&has_product=${hasProduct}`
      }
      if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.products = response.data.results
        this.count = response.data.count
      })
      .catch(() => {})
      .finally(() => {
        this.isFetching = false
      })
    },
    clickAddProduct () {
      this.showAddProductDialog = true
    },
    uncheckAll () {
      this.products = [...this.products.map(m => { return {...m, check: false } })]
    },
    updateQueryString (key, value) {
      var q = queryString.parse(location.search)
      q[key] = value
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
    }
  }
}
</script>

<style scoped>
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
.clickable {
  cursor: pointer;
}
</style>

<i18n>
{
  "en": {
    "weight": {
      "label": "Weight",
      "placeholder": "Min = 0.1 kg | Max = 60 kg",
      "hint": "Set this weight to all products in this page"
    }
  },
  "id": {
    "weight": {
      "label": "Berat",
      "placeholder": "Min = 0.1 kg | Maks = 60 kg",
      "hint": "Terapkan berat ini untuk semua produk di halaman ini"
    }
  }
}
</i18n>